module.exports = __webpack_public_path__ + "img/richeng.c2dbc4cc.png";